import { MODE_KEY_SUFFIX } from "constants/booksHandoff";

export const getModeKey = (fieldKey: string): string =>
  `${fieldKey}${MODE_KEY_SUFFIX}`;
